import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { List, X, ArrowUpRight } from "@phosphor-icons/react";
import { NAV_LINKS, COMPANY } from "../data/content";

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      data-testid="site-navbar"
      className={`sticky top-0 z-40 border-b border-[var(--sifra-line)] bg-white/90 backdrop-blur transition-shadow ${
        scrolled ? "shadow-[0_1px_0_0_var(--sifra-line)]" : ""
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-16 md:h-20">
        <Link
          to="/"
          data-testid="navbar-logo"
          className="flex items-center gap-3"
        >
          <img
            src="/sifra-logo.jpeg"
            alt="Sifra Enterprises"
            className="h-10 w-10 md:h-11 md:w-11 object-contain"
          />
          <span className="flex flex-col leading-tight">
            <span className="font-display font-black text-lg tracking-tighter">
              {COMPANY.name}
            </span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm font-semibold tracking-tight link-underline ${
                  isActive
                    ? "text-[var(--sifra-ink)]"
                    : "text-[var(--sifra-ink-soft)] hover:text-[var(--sifra-ink)]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <Link
          to="/contact"
          data-testid="navbar-cta-quote"
          className="hidden lg:inline-flex items-center gap-2 bg-[var(--sifra-ink)] text-white px-5 py-3 text-xs tracking-label font-semibold uppercase hover:bg-[var(--sifra-accent)] transition-colors duration-300"
        >
          Get a Quote <ArrowUpRight size={14} weight="bold" />
        </Link>

        <button
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
          data-testid="navbar-mobile-toggle"
          className="lg:hidden inline-flex items-center justify-center w-10 h-10 border border-[var(--sifra-line)]"
        >
          {open ? <X size={18} weight="bold" /> : <List size={18} weight="bold" />}
        </button>
      </div>

      {/* Mobile sheet */}
      {open && (
        <div
          className="lg:hidden border-t border-[var(--sifra-line)] bg-white"
          data-testid="navbar-mobile-panel"
        >
          <div className="px-6 py-4 flex flex-col">
            {NAV_LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                data-testid={`nav-link-mobile-${l.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `py-3 border-b border-[var(--sifra-line)] text-base font-semibold ${
                    isActive
                      ? "text-[var(--sifra-ink)]"
                      : "text-[var(--sifra-ink-soft)]"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              data-testid="navbar-cta-quote-mobile"
              className="mt-4 inline-flex items-center justify-center gap-2 bg-[var(--sifra-ink)] text-white px-5 py-4 text-xs tracking-label font-semibold uppercase"
            >
              Get a Quote <ArrowUpRight size={14} weight="bold" />
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
